var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContent"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.structure.ourTitle))]),_c('div',{staticClass:"link"}),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.structure.ourContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }